// extracted by mini-css-extract-plugin
module.exports = {"iconSelect":"IconSelect_iconSelect__2n2xL","heading":"IconSelect_heading__2Qc6l","highlight":"IconSelect_highlight__hLKqP"};